import { ApolloError, NetworkStatus } from "@apollo/client";
import { useEffect, useState } from "react";

interface RefreshResult {
  error?: ApolloError;
  networkStatus: NetworkStatus;
  data?: unknown;
}

export function useRefreshError(
  { error, networkStatus, data }: RefreshResult,
  queryKey: string
): ApolloError | undefined {
  const [previous, setPrevious] = useState<{
    queryKey: string;
    error: ApolloError;
  }>();
  const succeeded = networkStatus === NetworkStatus.ready && data !== undefined;
  useEffect(() => {
    if (error) setPrevious({ queryKey, error });
    else if (succeeded) setPrevious(undefined);
  }, [error, queryKey, succeeded]);

  // Starting a retry clears Apollo's error before the data is current again.
  return (
    error ||
    (!succeeded && previous?.queryKey === queryKey ? previous.error : undefined)
  );
}
